export enum ProductKey {
  // TRANSFER
  Collect = "collect",
  Transfer = "transfer",
  Transit = "transit",
  Return = "return",
  VehicleStorageExit = "vehicle-storage-exit",
  MediumLongDistance = "medium-long-distance",

  // BASIC REPLACEMENT
  ReplacementVehicleTransfer = "transfer-replacement-vehicle",

  // MAINTENANCE
  TireCheck = "tireInflation-topping",
  CaflerReady = "fine-tunning",
  MotorbikeBasicMaintenance = "motorbike-basic-maintenance",
  MotorbikeCompleteMaintenance = "motorbike-complete-maintenance",
  CarBasicMaintenance = "car-basic-maintenance",
  CarCompleteMaintenance = "car-complete-maintenance",
  CarMediumMaintenance = "car-medium-maintenance",
  WorkshopAtHome = "car-service",
  Tyres = "tyres",
  ChecklistTopping = "checklist-topping",

  // CLEAN UP
  CaflerCompleteAtvWash = "complete-car-wash-topping",
  IntegralWashing = "integral-washing",
  HeadlightPolishing = "headlight-polishing",
  TunnelCompleteCarWash = "tunnel-complete-car-wash",
  TunnelWash = "tunnel-exterior-car-wash-topping",
  Upholstery5Seats = "upholstery-detail-wash-5-seats",
  MotorbikeWash = "motorbike-wash-topping",
  BasicTunnelCarWash = "tunnel-basic-car-wash",

  // Refueling
  Refueling = "refueling-car-topping",
  RefuelingTopping = "refueling-topping",

  // ITV
  TechnicalInspection = "technical-inspection",
  PreMOT = "pre-mot",
  PreMot360 = "360-pre-mot",
  MotDieselCarEs = "mot-diesel-car-es",
  MotDieselCarFr = "mot-diesel-car-fr",
  MotDieselVanEs = "mot-diesel-van-es",
  MotElectricCarEs = "mot-electric-car-es",
  MotElectricCarFr = "mot-electric-car-fr",
  MotElectricVanEs = "mot-electric-van-es",
  MotFuelCarEs = "mot-fuel-car-es",
  MotFuelCarFr = "mot-fuel-car-fr",
  MotFuelCarUk = "mot-fuel-car-uk",
  MotGasCarFr = "mot-gas-car-fr",
  MotGasVanEs = "mot-gas-van-es",
  MotHomologation = "mot-homologation",
  MotHybridCarEs = "mot-hybrid-car-es",
  MotHybridCarFr = "mot-hybrid-car-fr",
  MotHybridVanEs = "mot-hybrid-van-es",
  MotMotorbike125Es = "mot-motorbike-125cc-es",
  MotMotorbikeEs = "mot-motorbike-es",
  MotMotorbikeUk = "mot-motorbike-uk",
  MotElectricMotorbike125 = "motorbike-electric-mot",
  MotElectricMotorbikePlus125 = "motorbike-electric-mot-125cc",

  // INSURANCE
  InsuranceTopping = "insurance-topping",
  CaflerFreshAtvTopping = "caflerFresh-topping",

  // PARKING
  ValetTrainStation = "valet-station",
  Parking = "parking",

  // FORMALITIES
  OwnershipChange = "ownership-change",

  // ASSISTANCE
  TowTruck = "tow_truck",

  // OTHER
  VehicleStorage = "vehicle-storage",

  // New Added From Front (Products Group)
  SpecializedCenter = "specialized-center-wash",
  MaintenancePack = "maintenance-pack",
  WhatYouWant = 'open-form',
}

export const ITV_PRODUCTS: ProductKey[] = [
  ProductKey.PreMOT,
  ProductKey.PreMot360,
  ProductKey.MotDieselCarEs,
  ProductKey.MotDieselCarFr,
  ProductKey.MotDieselVanEs,
  ProductKey.MotElectricCarEs,
  ProductKey.MotElectricCarFr,
  ProductKey.MotElectricVanEs,
  ProductKey.MotFuelCarEs,
  ProductKey.MotFuelCarFr,
  ProductKey.MotFuelCarUk,
  ProductKey.MotGasCarFr,
  ProductKey.MotGasVanEs,
  ProductKey.MotHomologation,
  ProductKey.MotHybridCarEs,
  ProductKey.MotHybridCarFr,
  ProductKey.MotHybridVanEs,
  ProductKey.MotMotorbike125Es,
  ProductKey.MotMotorbikeEs,
  ProductKey.MotMotorbikeUk,
  ProductKey.MotElectricMotorbike125,
  ProductKey.MotElectricMotorbikePlus125,
  ProductKey.TechnicalInspection
];

export const RegularITV: ProductKey[] = [
  ProductKey.MotDieselCarEs,
  ProductKey.MotDieselCarFr,
  ProductKey.MotDieselVanEs,
  ProductKey.MotElectricCarEs,
  ProductKey.MotElectricCarFr,
  ProductKey.MotElectricVanEs,
  ProductKey.MotFuelCarEs,
  ProductKey.MotFuelCarFr,
  ProductKey.MotFuelCarUk,
  ProductKey.MotGasCarFr,
  ProductKey.MotGasVanEs,
  ProductKey.MotHybridCarEs,
  ProductKey.MotHybridCarFr,
  ProductKey.MotHybridVanEs,
  ProductKey.MotMotorbike125Es,
  ProductKey.MotMotorbikeEs,
  ProductKey.MotMotorbikeUk,
  ProductKey.MotElectricMotorbike125,
  ProductKey.MotElectricMotorbikePlus125,
  ProductKey.TechnicalInspection
];


export const TransferProduct: ProductKey[] = [
  ProductKey.Collect,
  ProductKey.Transfer,
  ProductKey.Transit,
  ProductKey.Return,
  ProductKey.VehicleStorageExit,
  ProductKey.MediumLongDistance,
];

export const EnableSecondaryProduct: ProductKey[] = [
  ProductKey.Transfer,
  ProductKey.Transit,
  ProductKey.Collect
]

export const TransferServiceDetails: ProductKey[] = [
  ProductKey.Collect,
  ProductKey.Transfer,
  ProductKey.Transit,
  ProductKey.Return,
  ProductKey.VehicleStorageExit,
  ProductKey.MediumLongDistance,
];



